/**
 * Skip to Content Link
 *
 * WCAG 2.4.1 requirement - provides a mechanism to bypass blocks of content
 * that are repeated on multiple pages (navigation, headers, etc.)
 *
 * This link is visually hidden until focused, allowing keyboard users
 * to quickly jump to the main content.
 */

export function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="
        sr-only
        focus:not-sr-only
        focus:fixed
        focus:left-4
        focus:top-4
        focus:z-50
        focus:rounded-lg
        focus:bg-purple-600
        focus:px-4
        focus:py-2
        focus:text-sm
        focus:font-medium
        focus:text-white
        focus:shadow-lg
        focus:outline-none
        focus:ring-2
        focus:ring-purple-600
        focus:ring-offset-2
        dark:focus:bg-purple-500
        dark:focus:ring-purple-500
      "
    >
      Skip to main content
    </a>
  )
}
